import type { TFunction } from 'i18next';
import type { ImportBatch } from '@/api/imports';

/**
 * What a batch's before-opening counts say (TMMAPI-0123; DATA-008: state what a count counts).
 * `beforeOpeningCount` counts rows SKIPPED; `beforeOpeningImportedCount` counts rows IMPORTED anyway.
 * The API never sends both non-zero; a zero count has no line, so a batch with neither returns [].
 */
export function beforeOpeningLabels(
  t: TFunction,
  batch: Pick<ImportBatch, 'beforeOpeningCount' | 'beforeOpeningImportedCount'>,
): string[] {
  const lines: string[] = [];
  if (batch.beforeOpeningCount > 0) {
    lines.push(t('imports.beforeOpeningSkipped', { count: batch.beforeOpeningCount }));
  }
  if (batch.beforeOpeningImportedCount > 0) {
    lines.push(t('imports.beforeOpeningImported', { count: batch.beforeOpeningImportedCount }));
  }
  return lines;
}
